import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { AirlinePassengerCriteria, SupplierPassengerCriteria } from '../Models/MasterPassengerInfoProperties';


@Injectable({
  providedIn: 'root'
})
export class MasterPassengerInfoService {

  baseUrl = environment.baseUrl;
  backSystemUrl = environment.backSystemBaseUrl;
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
  constructor(private http: HttpClient) { }

   CreateSuppMasterPassengerCriteria(newobj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/MasterPassengerInfo/CreatePassengerCriteria', newobj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }
  UpdateSuppMasterPassengerCriteria(newobj): Observable<boolean> {
    return this.http.post<boolean>(this.baseUrl + '/MasterPassengerInfo/UpdateSuppMasterPassengerCriteria', newobj, this.httpOptions)
      .pipe(map((data: any) => {
        return data;
      }), catchError(error => { return throwError(error); }))
  }

  GetAllSupplierMasterPassengerInfo(): Observable<SupplierPassengerCriteria[]> {
    return this.http.get<SupplierPassengerCriteria[]>(this.baseUrl + '/MasterPassengerInfo/GetAllSupplierMasterPassengerCriteria').pipe(map((data: any) => {
      return data;
    }), catchError(error => { return throwError(error); }))
  }

  GetSupplierCriteriaByID(Id): Observable<SupplierPassengerCriteria> {

    const supplierId = parseInt(Id, 10);

    return this.http.get<SupplierPassengerCriteria>(this.baseUrl + `/MasterPassengerInfo/GetAllSupplierMasterPassengerCriteriaById/${supplierId}`).pipe(map((data: any) => {
      return data;
    }), catchError(error => { return throwError(error); }))
  }

  GetSupplierByIDForPassengerInfo(supplierId, airline): Observable<AirlinePassengerCriteria> {
    return this.http.get<AirlinePassengerCriteria>(this.baseUrl + `/MasterPassengerInfo/GetSupplierByIDForPassengerInfo/${supplierId}/${airline}`).pipe(map((data: any) => {
      return data;
    }), catchError(error => { return throwError(error); }))
  }

  DeleteCriteriaById(supplierId): Observable<boolean> {

    return this.http.post<boolean>(this.baseUrl + `/MasterPassengerInfo/DeleteCriteriaById/${supplierId}`, this.httpOptions).pipe(map((data: any) => {
      return data;
    }), catchError(error => { return throwError(error); }))
  }

}
